const FormLabel = (props) => {
  return (
    <>
      <label {...props} className="font-semibold mb-2 block">
        {props.children}
      </label>
    </>
  );
};

export default FormLabel;
